import React, { Dispatch, SetStateAction } from "react";
interface IContextType {
    isLoggedIn: boolean | undefined;
    setLoggedIn: Dispatch<SetStateAction<boolean | undefined>>;
}
const defaultState = {
    isLoggedIn: undefined,
    setLoggedIn: (() => {}) as Dispatch<SetStateAction<boolean | undefined>>
}
export const Context = React.createContext<IContextType>(defaultState);